/* unplugin-vue-components disabled */import { render } from "./TagManagement.vue?vue&type=template&id=77ef1688&scoped=true"
import script from "./TagManagement.vue?vue&type=script&lang=js"
export * from "./TagManagement.vue?vue&type=script&lang=js"

import "./TagManagement.vue?vue&type=style&index=0&id=77ef1688&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ef1688"]])

export default __exports__